(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/martech-helper/assets/javascripts/martech-helper.js') >= 0) return;  svs.modules.push('/components/accountservices/martech-helper/assets/javascripts/martech-helper.js');

'use strict';

svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.martech_helper = svs.accountservices.martech_helper || {};
svs.accountservices.martech_helper.setPersonalizedContentFlag = async callback => {
  const logger = new svs.core.log.Logger('accountservices:martech-helper');
  const options = {
    method: 'GET',
    path: '/player/2/customizedsettings'
  };
  try {
    var _response$customizedS;
    const _await$svs$core$jupit = await svs.core.jupiter.callAsync(options),
      response = _await$svs$core$jupit.response,
      status = _await$svs$core$jupit.status;
    const customerProps = response === null || response === void 0 || (_response$customizedS = response.customizedSettings) === null || _response$customizedS === void 0 ? void 0 : _response$customizedS.properties;
    if (status === 'success' && customerProps) {
      const relevant = (customerProps === null || customerProps === void 0 ? void 0 : customerProps.personalizedContentSvs) === '1';
      const personalizedConsent = new svs.components.analytics.customEvents.WebConsentChanged(relevant);
      personalizedConsent.track();
      const declaredcustomerid = customerProps.declaredcustomerid || '';
      const trackAdobeUser = async () => {
        await svs.core.analytics.trackAdobeUser(declaredcustomerid).catch(error => {
          logger.warn('Could not trackAdobeUser with declaredcustomerid, error: ', error);
        });
        svs.core.userSession.set('userId', declaredcustomerid, () => {
          callback && callback();
        });
      };
      trackAdobeUser();
    } else {
      logger.warn('Could get properties from customizedsettings, error: ', (response === null || response === void 0 ? void 0 : response.error) || 'error');
      callback && callback();
    }
  } catch (error) {
    logger.warn('Could not set personalizedConsent.track on customer, error: ', error);
    callback && callback();
  }
};

 })(window);